var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wraper"},[_c('PageHeader'),_vm._v(" "),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-headband"},[_c('TheHeadband',{attrs:{"data":_vm.headband}})],1),_vm._v(" "),_c('div',{staticClass:"page-content-wraper"},[_c('nuxt')],1)]),_vm._v(" "),_c('PageFooter'),_vm._v(" "),_c('TheScrollTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }